



















































































































































































































import {
  defineComponent,
  computed,
  inject,
  ref,
  watch,
  Ref
} from '@vue/composition-api'
import UserAvatar from '@/components/UserAvatar.vue'
import PaymentStatusBadge from '@/components/PaymentStatusBadge.vue'
import moment from 'moment'
import { toDateString } from '@/lib/utils'
import { v4 as uuidv4 } from 'uuid'
import { useUnsavedWarning } from '@/composables/useUnsavedWarning'
import { useUpdater } from '@/composables/useUpdater'
import { useMutation } from '@vue/apollo-composable'
import userMutation from '@/lib/graphql/user.mutation.gql'
import activateIOSOrdersMutation from '@/lib/graphql/activateIOSOrders.mutation.gql'
import extendIOSOrdersMutation from '@/lib/graphql/extendIOSOrders.mutation.gql'
import extendAndroidOrdersMutation from '@/lib/graphql/extendAndroidOrders.mutation.gql'
import activateAndroidOrdersMutation from '@/lib/graphql/activateAndroidOrders.mutation.gql'
import activateWechatOrdersMutation from '@/lib/graphql/activateWechatOrders.mutation.gql'
import refundWechatOrderMutation from '@/lib/graphql/refundWechatOrder.mutation.gql'
import userQuery from '@/lib/graphql/user.query.gql'
import { useAxios } from '@vue-composable/axios'
import { useAuth } from '@/composables/useAuth'
import { useApp } from '@/composables/useApp'
import { AxiosBasicCredentials } from 'axios'

export default defineComponent({
  components: {
    UserAvatar,
    PaymentStatusBadge
  },

  setup(_, { root }) {
    const manualPremium = ref(false)

    // eslint-disable-next-line
    const { data: userRef, loading } = inject('user') as any

    const hasSubscriptions = computed(() => {
      const user = userRef.value
      if (user) {
        return (
          user.ios_orders.length ||
          user.android_orders.length ||
          user.wechat_orders.length ||
          user.native_orders.length
        )
      }
      return false
    })

    const toDate = moment

    const orders = computed(
      () =>
        (userRef.value &&
          [
            {
              title: 'iOS orders',
              data: userRef.value.ios_orders,
              orderType: 'ios',
              rowKey: 'transaction_id',
              columns: [
                {
                  title: 'transaction id',
                  dataIndex: 'transaction_id',
                  fixed: 'left'
                },
                {
                  title: 'status',
                  dataIndex: 'status',
                  scopedSlots: { customRender: 'status' }
                },
                {
                  title: 'expires at',
                  dataIndex: 'expires_at',
                  scopedSlots: { customRender: 'date' }
                },
                {
                  title: 'updated at',
                  dataIndex: 'updated_at',
                  scopedSlots: { customRender: 'date' }
                },
                {
                  title: 'extension',
                  dataIndex: 'ios_order_extension_requests',
                  scopedSlots: { customRender: 'extension' }
                }
              ]
            },
            {
              title: 'Google Play orders',
              orderType: 'android',
              data: userRef.value.android_orders,
              rowKey: 'subscription_id',
              columns: [
                {
                  title: 'package name',
                  dataIndex: 'package_name',
                  fixed: 'left'
                },
                {
                  title: 'subscription id',
                  dataIndex: 'subscription_id'
                },
                {
                  title: 'status',
                  dataIndex: 'status',
                  scopedSlots: { customRender: 'status' }
                },
                {
                  title: 'extension',
                  dataIndex: 'android_order_extension_requests',
                  scopedSlots: { customRender: 'extension' }
                },
                {
                  title: 'expires at',
                  dataIndex: 'expires_at',
                  scopedSlots: { customRender: 'date' }
                },
                {
                  title: 'updated at',
                  dataIndex: 'inserted_at',
                  scopedSlots: { customRender: 'date' }
                },
                {
                  title: ' ',
                  scopedSlots: { customRender: 'revoke' },
                  fixed: 'right'
                }
              ]
            },
            {
              title: 'Wechat pay orders',
              orderType: 'wechat',
              data: userRef.value.wechat_orders,
              rowKey: 'order_number',
              columns: [
                {
                  title: 'order number',
                  dataIndex: 'order_number'
                },
                {
                  title: 'fee',
                  dataIndex: 'fee'
                },
                {
                  title: 'status',
                  dataIndex: 'status',
                  scopedSlots: { customRender: 'status' }
                },
                {
                  title: 'expires at',
                  dataIndex: 'expires_at',
                  scopedSlots: { customRender: 'date' }
                },
                {
                  title: 'updated at',
                  dataIndex: 'inserted_at',
                  scopedSlots: { customRender: 'date' }
                },
                {
                  title: ' ',
                  scopedSlots: { customRender: 'refund' }
                }
              ]
            },
            {
              title: 'Coupon orders',
              orderType: 'coupon',
              data: userRef.value.native_orders.filter(
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (o: any) => o.source === 'coupon'
              ),
              rowKey: 'id',
              columns: [
                {
                  title: 'order number',
                  dataIndex: 'id'
                },
                {
                  title: 'status',
                  dataIndex: 'status',
                  scopedSlots: { customRender: 'status' }
                },
                {
                  title: 'fulfilled at',
                  dataIndex: 'fulfilled_at',
                  scopedSlots: { customRender: 'date' }
                },
                {
                  title: 'expires at',
                  dataIndex: 'expires_at',
                  scopedSlots: { customRender: 'date' }
                }
              ]
            },
            {
              title: 'Stripe orders',
              orderType: 'stripe',
              data: userRef.value.native_orders.filter(
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (o: any) => o.source === 'stripe'
              ),
              rowKey: 'id',
              columns: [
                {
                  title: 'subscription id',
                  dataIndex: 'subscription_id'
                },
                {
                  title: 'status',
                  dataIndex: 'status',
                  scopedSlots: { customRender: 'status' }
                },
                {
                  title: 'fulfilled at',
                  dataIndex: 'fulfilled_at',
                  scopedSlots: { customRender: 'date' }
                },
                {
                  title: 'expires at',
                  dataIndex: 'expires_at',
                  scopedSlots: { customRender: 'date' }
                }
              ]
            }
          ].filter(o => o.data.length > 0)) ??
        []
    )

    watch(
      manualPremium,
      manualPremium => {
        if (manualPremium && expiresAt.value == null) {
          expiresAt.value = moment().add(1, 'days')
        }
      },
      { flush: 'pre' }
    )

    const {
      updateBag,
      modelProps: { inserted_at: insertedAt, expires_at: expiresAt }
    } = useUpdater(userRef, ['inserted_at', 'expires_at'])

    const { markAsDirty, resetDirty, isDirty } = useUnsavedWarning()
    watch(
      () => updateBag,
      bag => {
        const isEqual = Object.keys(bag).every(
          k => typeof bag[k] === 'undefined' || bag[k] === userRef.value[k]
        )
        if (isEqual) {
          resetDirty()
        } else {
          markAsDirty()
        }
      },
      { deep: true }
    )

    const { mutate, loading: isSaving, onError, onDone } = useMutation(
      userMutation,
      () => ({
        variables: {
          id: userRef.value.id,
          set: updateBag
        },
        update: cache => {
          // eslint-disable-next-line
          const data: any = cache.readQuery({
            query: userQuery,
            variables: { id: userRef.value.id }
          })

          Object.keys(updateBag)
            .filter(k => typeof updateBag[k] !== 'undefined')
            .forEach(k => {
              data.users_by_pk[k] = updateBag[k]
            })

          cache.writeQuery({
            query: userQuery,
            data,
            variables: { id: userRef.value.id }
          })
        }
      })
    )

    const submit = () => {
      mutate()
    }

    onDone(() => {
      resetDirty()
    })

    // eslint-disable-next-line
    onError((err: any) => {
      console.error(err)
      root?.$message.error('Something went wrong')
    })

    /// Activation
    const activateMutationOptions = (key: string) => () => ({
      variables: {
        userId: userRef.value.id
      },
      // eslint-disable-next-line
      update: (cache: any, { data: newData }: { data: any }) => {
        // eslint-disable-next-line
        const data: any = cache.readQuery({
          query: userQuery,
          variables: { id: userRef.value.id }
        })
        // eslint-disable-next-line
        const oldOrders: any[] = data.users_by_pk[key] || []
        // eslint-disable-next-line
        const newOrders: any[] = newData[`update_${key}`].returning
        const merged = oldOrders.map(order => {
          const updated = newOrders.find(newOrder => newOrder.id === order.id)
          return updated || order
        })

        data.users_by_pk[key] = merged

        cache.writeQuery({
          query: userQuery,
          variables: { id: userRef.value.id },
          data
        })
      }
    })

    const activateIOSMut = useMutation(
      activateIOSOrdersMutation,
      // eslint-disable-next-line
      // @ts-ignore
      activateMutationOptions('ios_orders')
    )
    const activateAndroidMut = useMutation(
      activateAndroidOrdersMutation,
      // eslint-disable-next-line
      // @ts-ignore
      activateMutationOptions('android_orders')
    )
    const activateWechatMut = useMutation(
      activateWechatOrdersMutation,
      // eslint-disable-next-line
      // @ts-ignore
      activateMutationOptions('wechat_orders')
    )

    const extendIOSMut = useMutation(extendIOSOrdersMutation, {})
    const extendAndroidMut = useMutation(extendAndroidOrdersMutation, {})
    const extendingOrder = ref<any>(null)
    const extendingOrderDays = ref(0)
    const showExtendOrderModal = (order: any) => {
      extendingOrder.value = order
    }
    const cancelExtending = () => {
      extendingOrder.value = null
    }

    const isOrderExtending = computed(
      () => extendIOSMut.loading.value || extendAndroidMut.loading.value
    )
    const extendOrder = async () => {
      const order = extendingOrder.value
      const item = order?.data?.[0]
      if (item.__typename === 'ios_orders') {
        await extendIOSMut.mutate({
          id: uuidv4(),
          transactionId: item.transaction_id,
          orderId: item.id,
          days: extendingOrderDays.value,
          timestamp: new Date().toDateString()
        })
      } else {
        await extendAndroidMut.mutate({
          id: uuidv4(),
          token: item.token,
          orderId: item.id,
          days: extendingOrderDays.value,
          timestamp: new Date().toDateString()
        })
      }
      cancelExtending()
      // return null
    }

    const activate = (type: string) => {
      switch (type) {
        case 'ios':
          activateIOSMut.mutate()
          break
        case 'android':
          activateAndroidMut.mutate()
          break
        case 'wechat':
          activateWechatMut.mutate()
          break
      }
    }
    const isActivating = (type: string) =>
      computed(() => {
        switch (type) {
          case 'ios':
            return activateIOSMut.loading.value
          case 'android':
            return activateAndroidMut.loading.value
          case 'wechat':
            return activateWechatMut.loading.value
        }
      })

    const refundWechatOrderMut = useMutation(refundWechatOrderMutation)
    const refundWechatOrderLoading = refundWechatOrderMut.loading
    const refundWechatOrderError = refundWechatOrderMut.error
    const refundWechatOrder = async (order: { id: string }) => {
      await refundWechatOrderMut.mutate({ id: order.id })
      await calcExp()
    }
    // eslint-disable-next-line
    refundWechatOrderMut.onError((err: any) => {
      console.error(err)
      root?.$message.error('Failed to refund')
    })

    /// Modal
    // eslint-disable-next-line
    const order: Ref<null | any> = ref(null)
    const modalTitle = computed(() => {
      return `#${order.value?.data.transaction_id ??
        order.value?.data?.info?.orderId}`
    })
    const modalVisible = ref(false)
    // eslint-disable-next-line
    const showOrder = (val: any) => {
      order.value = val
      modalVisible.value = true
    }
    const hideOrder = () => {
      order.value = null
    }

    const { currentApp } = useApp()
    const { username, userToken } = useAuth()
    const auth = {
      username: username.value,
      password: userToken.value
    } as AxiosBasicCredentials
    const {
      data: calcExpResult,
      loading: calcExpErrorLoading,
      error: calExpError,
      exec: calcExpExec
    } = useAxios()
    const calcExp = () => {
      calcExpExec({
        url: `${currentApp.value.voidApiUri}/admin/users/${userRef.value.id}/recal_exp`,
        method: 'POST',
        auth
      })
    }
    watch(
      calExpError,
      error => {
        if (error) {
          console.error(error)
          root.$notification.error({
            message: 'Error',
            description: 'An error occurred'
          })
        }
      },
      { immediate: true }
    )

    watch(calcExpResult, result => {
      if (result == null) {
        return
      }
      insertedAt.value = result.expires_at && toDate(result.expires_at)
    })

    const {
      data: revokeAndroidOrderResult,
      loading: revokeAndroidOrderErrorLoading,
      error: revokeAndroidOrderError,
      exec: revokeAndroidOrderExec
    } = useAxios()
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const revokeAndroidOrder = (order: any) => {
      root.$confirm({
        title: 'Are you sure you want to revoke this order?',
        onOk() {
          revokeAndroidOrderExec({
            url: `${currentApp.value.voidApiUri}/admin/android_orders/${order.id}/revoke`,
            method: 'POST',
            auth
          })
        }
      })
    }

    watch([revokeAndroidOrderResult, revokeAndroidOrderError], ([, error]) => {
      if (error) {
        root.$notification.error({
          message: 'Error',
          description: 'An error occurred'
        })
        return
      }

      root.$notification.info({
        message: 'Revoked',
        description: 'Android order has been revoked'
      })
    })

    return {
      calcExp,
      calcExpErrorLoading,

      manualPremium,
      expiresAt,
      insertedAt,

      modalVisible,
      modalTitle,
      order,
      showOrder,
      hideOrder,

      loading,
      toDate,
      user: userRef,
      hasSubscriptions,

      toDateString,
      orders,

      activate,
      isActivating,

      submit,
      isDirty,
      isSaving,

      revokeAndroidOrder,
      revokeAndroidOrderErrorLoading,

      refundWechatOrder,
      refundWechatOrderLoading,
      refundWechatOrderError,

      extendOrder,
      isOrderExtending,
      extendingOrder,
      cancelExtending,
      showExtendOrderModal,
      extendingOrderDays
    }
  }
})
